<template>
  <div class="container">
    <table class="table-list" cellspacing="0">
      <caption>
          Confirmed IRF-Assessed RECIST v1.1 ORR and DOR
      </caption>
      <thead>
        <tr>
          <th>Variable</th>
          <th>Cohort 1  (N = 119)</th>
          <th>Cohort 2  (N = 310)</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, key) in dataRow" :key="key">
          <td title="Variable">{{row.col1}}</td>
          <td title="Cohort 1  (N = 119)">{{row.col2}}</td>
          <td title="Cohort 2  (N = 310)">{{row.col3}}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3">
            <small>
              A number of patients in both cohorts, including those who discontinued treatment, experienced sustained responses<br/><br/>
              CR, complete response; NE, not estimable.<br/>
              Patients with missing or unevaluable response status: a 19 in Cohort 1 and b 46 in Cohort 2. c No death or IRF-assessed RECIST v1.1 PD event.
            </small>
          </td>
        </tr>
      </tfoot>
    </table>
    <foot-component text=""></foot-component>
    <template>
      <router-link to="/step5-3" class="btn-prev el-icon-arrow-left"></router-link>
      <router-link
      to="/step5-5" class="btn-next el-icon-arrow-right"></router-link>
    </template>
  </div>
</template>

<script>
import footText from './footText'
export default {
  name: 'page5',
  data () {
    return {
      dataRow: [
        {
          'col1': 'ORR (95% CI)',
          'col2': '24% (16, 32)a',
          'col3': '16% (13, 21)b'
        },
        {
          'col1': 'CR rate',
          'col2': '8%',
          'col3': '7%'
        },
        {
          'col1': 'DOR, median (95% CI)',
          'col2': 'NE (30.4 mo, NE)',
          'col3': '24.8 mo(13.8, 30.4)'
        },
        {
          'col1': 'Patients with ongoing responses',
          'col2': '19 of 28',
          'col3': '21 of 51'
        }
      ]
    }
  },
  components: {
    'foot-component': footText
  }
}
</script>

<style scoped>
.table-list caption {
  text-align:left;background:none;color:#1367a2;
  border-bottom-width:5px;
}
.table-list th,
.table-list tbody td {
  padding:12px;border-bottom:solid 3px white;
}
.table-list th {background:#1367a2;color:white;border-bottom-width:12px;}
.table-list tbody td {background:#8ccee2 !important;color:white;}
a[class*="btn-"]{
  background:#1367a2;color:white;
}
a.btn-next {right:0;}
</style>



// WEBPACK FOOTER //
// src/components/step5/page5.vue